import store from 'store2'

import post from '../../../lib/post'

export default function(tag,done){

  var ombStore = store.namespace('omb')

  var token = ombStore('token')
  var email = ombStore('email')

  post(
    'data',
    {
      token: token,
      type: 'sequence',
      tag: tag,
      email: email,
    },
    function(error,result){
      if(error){
        done(error)
      } else {
        if(done){
          done(null,result)
        }
      }
    }
  )

}



// WEBPACK FOOTER //
// ./src/client/view/admin/lib/generateSequence.js